import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type SetAppPhotoAssetMutationVariables = Types.Exact<{
  setEventAssetId: Types.Scalars['ID'];
  payload: Types.SetAssetPayload;
  isMobile?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;

export type SetAppPhotoAssetMutation = {
  __typename?: 'Mutation';
  setEventAsset: { __typename?: 'Event'; id: string; hasMobilePhoto: boolean; mobilePhoto?: { __typename?: 'Photo'; id: string; url: string } | null };
};

export type SetAppPhotoV2UrlMobileMutationVariables = Types.Exact<{
  payload: Types.SetEventPhotoV2MobilePayload;
}>;

export type SetAppPhotoV2UrlMobileMutation = { __typename?: 'Mutation'; setEventPhotoV2UrlMobile: { __typename?: 'Event'; id: string; photoV2UrlMobile?: string | null } };

export const SetAppPhotoAssetDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetAppPhotoAsset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'setEventAssetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetAssetPayload' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isMobile' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setEventAsset' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'setEventAssetId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'isMobile' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'isMobile' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMobilePhoto' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mobilePhoto' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetAppPhotoAssetMutationFn = Apollo.MutationFunction<SetAppPhotoAssetMutation, SetAppPhotoAssetMutationVariables>;

/**
 * __useSetAppPhotoAssetMutation__
 *
 * To run a mutation, you first call `useSetAppPhotoAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAppPhotoAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAppPhotoAssetMutation, { data, loading, error }] = useSetAppPhotoAssetMutation({
 *   variables: {
 *      setEventAssetId: // value for 'setEventAssetId'
 *      payload: // value for 'payload'
 *      isMobile: // value for 'isMobile'
 *   },
 * });
 */
export function useSetAppPhotoAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetAppPhotoAssetMutation, SetAppPhotoAssetMutationVariables>) {
  return ApolloReactHooks.useMutation<SetAppPhotoAssetMutation, SetAppPhotoAssetMutationVariables>(SetAppPhotoAssetDocument, baseOptions);
}
export type SetAppPhotoAssetMutationHookResult = ReturnType<typeof useSetAppPhotoAssetMutation>;
export type SetAppPhotoAssetMutationResult = Apollo.MutationResult<SetAppPhotoAssetMutation>;
export type SetAppPhotoAssetMutationOptions = Apollo.BaseMutationOptions<SetAppPhotoAssetMutation, SetAppPhotoAssetMutationVariables>;
export const SetAppPhotoV2UrlMobileDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetAppPhotoV2UrlMobile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetEventPhotoV2MobilePayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setEventPhotoV2UrlMobile' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'photoV2UrlMobile' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetAppPhotoV2UrlMobileMutationFn = Apollo.MutationFunction<SetAppPhotoV2UrlMobileMutation, SetAppPhotoV2UrlMobileMutationVariables>;

/**
 * __useSetAppPhotoV2UrlMobileMutation__
 *
 * To run a mutation, you first call `useSetAppPhotoV2UrlMobileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAppPhotoV2UrlMobileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAppPhotoV2UrlMobileMutation, { data, loading, error }] = useSetAppPhotoV2UrlMobileMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetAppPhotoV2UrlMobileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetAppPhotoV2UrlMobileMutation, SetAppPhotoV2UrlMobileMutationVariables>) {
  return ApolloReactHooks.useMutation<SetAppPhotoV2UrlMobileMutation, SetAppPhotoV2UrlMobileMutationVariables>(SetAppPhotoV2UrlMobileDocument, baseOptions);
}
export type SetAppPhotoV2UrlMobileMutationHookResult = ReturnType<typeof useSetAppPhotoV2UrlMobileMutation>;
export type SetAppPhotoV2UrlMobileMutationResult = Apollo.MutationResult<SetAppPhotoV2UrlMobileMutation>;
export type SetAppPhotoV2UrlMobileMutationOptions = Apollo.BaseMutationOptions<SetAppPhotoV2UrlMobileMutation, SetAppPhotoV2UrlMobileMutationVariables>;
